import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { latestCollections } from '../mock';

export default function LatestCollection() {
  const [start, setStart] = useState(0);
  const visible = 4;
  const max = Math.max(0, latestCollections.length - visible);

  return (
    <section className="w-full bg-[#fafaf7] py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="text-[11px] tracking-[0.4em] uppercase text-[#7a1a2a] mb-3">Latest</div>
            <h2 className="serif text-4xl md:text-5xl font-light text-[#1a1a1a]">Latest Vitrified Tiles Collection</h2>
          </div>
          <div className="hidden md:flex gap-2">
            <button onClick={() => setStart(Math.max(0, start - 1))} disabled={start === 0} className="w-11 h-11 rounded-full border border-[#7a1a2a] text-[#7a1a2a] hover:bg-[#7a1a2a] hover:text-white disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-[#7a1a2a] transition-colors flex items-center justify-center">
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button onClick={() => setStart(Math.min(max, start + 1))} disabled={start === max} className="w-11 h-11 rounded-full border border-[#7a1a2a] text-[#7a1a2a] hover:bg-[#7a1a2a] hover:text-white disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-[#7a1a2a] transition-colors flex items-center justify-center">
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>

        <div className="overflow-hidden">
          <div className="flex transition-transform duration-700 ease-out" style={{ transform: `translateX(-${start * (100 / visible)}%)` }}>
            {latestCollections.map((c) => (
              <a href="#" key={c.name} className="shrink-0 w-1/2 md:w-1/4 px-2 group">
                <div className="img-zoom h-72 md:h-96 bg-neutral-200 relative">
                  <img src={c.image} alt={c.name} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                </div>
                <div className="pt-4 flex items-center justify-between">
                  <span className="serif text-xl text-[#1a1a1a]">{c.name}</span>
                  <span className="text-[#7a1a2a] opacity-0 group-hover:opacity-100 transition-opacity">&rarr;</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
